module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tab_boardStar":"Stared Boards","tab_boards":"Boards","tab_overview":"Overview"},"th":{"tab_boardStar":"บอร์ดที่ติดดาว","tab_boards":"บอร์ด","tab_overview":"ภาพรวม"}}')
  delete Component.options._Ctor
}
